import { useFormContext } from 'react-hook-form';
import { MultiValue } from 'react-select';

import { AutocompleteOptionForHookForm } from '@savgroup-front-common/types';

import { DefaultRubric, Facet } from '../../Datatable.types';

interface UseFilterDefaultArgs {
  filter: DefaultRubric;
  onChange?: (selectedFilter: DefaultRubric) => void;
  dataTestId?: string;
}

export const useFilterDefault = ({
  filter,
  onChange,
  dataTestId,
}: UseFilterDefaultArgs) => {
  const { getValues } = useFormContext();
  const buildFiltersOptions = (
    facets: Facet[],
  ): AutocompleteOptionForHookForm<Facet>[] => {
    return facets.map((facet) => ({
      value: facet.name || '',
      label: `${facet.label} - ( ${facet.count} )`,
      data: facet,
      dataTestId: `${dataTestId}_filterDefault_option_${facet.name}`,
    }));
  };

  const handleFilterSelected = (
    selectedValues: MultiValue<AutocompleteOptionForHookForm<Facet>>,
  ) => {
    const selectedFilter = {
      name: filter.name,
      label: filter.label,
      facets: selectedValues.map((selectedValue) => ({
        ...selectedValue.data,
        included: true,
      })),
      type: filter.type,
      filterName: `filterDefault_${filter.name}`,
    };

    if (onChange) {
      onChange(selectedFilter);
    }
  };

  return {
    filtersValue: getValues(`filterDefault_${filter.name}`) || [],
    buildFiltersOptions,
    handleFilterSelected,
  };
};
